import { useTranslation } from 'react-i18next';
import generateAssetURL from '../../../../../../utils/helpers/generateAssetURL';
import useAuth from '../../../../../../utils/hooks/useAuth';
import './interventionsListEmptyCase.scss';

const InterventionsListEmptyCase = () => {
  const { t } = useTranslation();
  const { schoolAssetsPath } = useAuth();

  const avatarIcon = generateAssetURL({
    asset: 'avatar_thumbs_up.svg',
    schoolAssetsPath: schoolAssetsPath
  });

  return (
    <div className='interventions-list-empty-case'>
      <img src={avatarIcon} alt='avatar thumbs up' />
      <div>{t('interventions_empty_case_no_issues')}</div>
    </div>
  );
};

export default InterventionsListEmptyCase;
